<template>
  <svg viewBox="0 0 18 18"><path fill-rule="nonzero" d="M.462 5.579l-.098.042A.693.693 0 00.4 6.86l6.677 3.115 3.128 7.597a.692.692 0 001.297-.044L17.04.912a.692.692 0 00-.887-.871L.462 5.579zm14.817-3.762l-4.503 13.506L8.255 9.2l-.046-.093a.692.692 0 00-.301-.271L2.52 6.32l12.759-4.503z" /></svg>
</template>

<script>
export default {
  name: 'Location'
}
</script>
